import React from 'react';
import invariant from 'invariant';

const ModalActions = ({ children }) => {
  const actions = React.Children.toArray(children);

  invariant(
    actions.length <= 2,
    'ModalActions only accepts two or less children elements'
  );

  return (
    <div className="l-flex-grid l-flex-grid--space-between">
      {actions.map((child, index) => (
        <div key={`modal-action-${index}`} className="l-flex-grid__item">
          {child}
        </div>
      ))}
    </div>
  );
};

export default ModalActions;
